<template>
    <div>
        <Field
            v-model="modelValue.name"
            :field="{
                adminComponent: 'AdminText',
                type: 'text',
                name: lang('delivery::delivery.fields.delivery_subject.fields.name'),
                readonly: props.readonly,
            }"
            label-position="left"
        />
        <Field
            v-model="modelValue.street"
            :field="{
                adminComponent: 'AdminText',
                type: 'text',
                name: lang('delivery::delivery.fields.delivery_subject.fields.street'),
                readonly: props.readonly,
            }"
            label-position="left"
        />
        <Field
            v-model="modelValue.city"
            :field="{
                adminComponent: 'AdminText',
                type: 'text',
                name: lang('delivery::delivery.fields.delivery_subject.fields.city'),
                readonly: props.readonly,
            }"
            label-position="left"
        />
        <Field
            v-model="modelValue.zipCode"
            :field="{
                adminComponent: 'AdminText',
                type: 'text',
                name: lang('delivery::delivery.fields.delivery_subject.fields.zip'),
                readonly: props.readonly,
            }"
            label-position="left"
        />
        <Field
            v-model="modelValue.country"
            :field="{
                adminComponent: 'AdminSelect',
                type: 'select',
                name: lang('delivery::delivery.fields.delivery_subject.fields.country'),
                readonly: props.readonly,
            }"
            label-position="left"
            :options="[{ id: 'CZ', name: 'Česká republika' }]"
        />
        <Field
            v-model="modelValue.phone"
            :field="{
                adminComponent: 'AdminTel',
                type: 'tel',
                name: lang('delivery::delivery.fields.delivery_subject.fields.phone'),
                readonly: props.readonly,
            }"
            label-position="left"
        />
        <Field
            v-model="modelValue.email"
            :field="{
                adminComponent: 'AdminEmail',
                type: 'email',
                name: lang('delivery::delivery.fields.delivery_subject.fields.email'),
                readonly: props.readonly,
            }"
            label-position="left"
        />
    </div>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: Object,
});

const props = withDefaults(defineProps<FieldComponent>(), {});
</script>
